import VesselAutoComplete from 'components/common/VesselAutoComplete';
import _ from 'lodash';
import { CircularProgress, RaisedButton } from 'material-ui';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import api from 'services';
import styles from 'styles';
import Detentions from '../Vessels/Single/Rows/Detentions';
import Sanctions from '../Vessels/Single/Rows/Sanctions';
import { addNotification } from 'actions/notifications/notifications';

function DetentionsContent({ addNotification }) {
    const [vessel, setVessel] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [complianceId, setComplianceId] = useState(null);
    const [detentions, setDetentions] = useState(getDefaultDetentionsSanctions().detentions);
    const [sanctions, setSanctions] = useState(getDefaultDetentionsSanctions().sanctions);
    const [clearDetentions, setClearDetentions] = useState(false);

    const getSanctions = async (imo) => {
        const vesselSanctions = await api.getVesselSanctions(imo);

        if (vesselSanctions.data) {
            const { detentions: detentionsFromDB, sanctions: sanctionsFromDB, _id } = vesselSanctions.data;
            const {
                detentions: defaultDetentions,
                sanctions: defaultSanctions,
            } = getDefaultDetentionsSanctions();

            setDetentions(detentionsFromDB.length ? detentionsFromDB : defaultDetentions);

            sanctionsFromDB.forEach((s) => {
                s.programs = s.program;
            });

            if (sanctionsFromDB.length === 1) {
                sanctionsFromDB.push(defaultSanctions[1]);
                setSanctions(sanctionsFromDB);
            } else if (sanctionsFromDB.length === 2) {
                setSanctions(sanctionsFromDB);
            } else {
                setSanctions(defaultSanctions);
            }
            setComplianceId(_id);
            setIsLoading(false);
        }
    };

    const selectVessel = async (selectedVessel) => {
        setVessel(selectedVessel);
        setIsLoading(true);

        await getSanctions(selectedVessel.imoNumber);
    };

    const changeField = (changes) => {
        const _sanctions = { sanctions: _.cloneDeep(sanctions) };
        const _detentions = { detentions: _.cloneDeep(detentions) };

        changes.forEach((change) => {
            if (change.field.includes('sanctions')) {
                _.set(_sanctions, change.field, change.value);
            } else {
                _.set(_detentions, change.field, change.value);
            }
        });
        setSanctions(_sanctions.sanctions);
        setDetentions(_detentions.detentions);
    };

    const updateCompliance = async (type) => {
        let _sanctions;
        let _detentions;
        if (type === 'detentions') {
            if (detentions.length === 1) {
                if (
                    !detentions[0]._id &&
                    !detentions[0].port._id &&
                    !detentions[0].detained &&
                    !detentions[0].released &&
                    !detentions[0].deficienciesNature.length &&
                    !detentions[0].deficienciesNumber
                ) {
                    _detentions = [];
                }
            }

            if (!_detentions && detentions.find(d => (d.port && !d.detained) || (!d.port && d.detained))) {
                addNotification({
                    title: 'Error',
                    message: 'Port and detained date are required for detentions',
                    level: 'error',
                    _id: new Date().getMilliseconds(),
                    autoDismiss: 3,
                });
                return;
            }

            detentions.forEach((item) => {
                if (item.port && item.port.name) {
                    item.externalPortName = item.port.name;
                    item.portId = item.port._id;
                }
                item.deficiencies = {
                    list: item.deficienciesNature,
                    knownNumber: parseInt(item.deficienciesNumber),
                };
            });
        } else {
            if (sanctions.find(s => s.remarks && !(s.programs.filter(Boolean).length && s.list))) {
                addNotification({
                    title: 'Error',
                    message: 'List and Program are required if remarks are set',
                    level: 'error',
                    _id: new Date().getMilliseconds(),
                    autoDismiss: 3,
                });
                return;
            }

            const sanctionsLength = sanctions.filter(s => s.list || s.programs.filter(Boolean).length).length;

            if (sanctionsLength === 0) {
                _sanctions = [];
            } else if (!sanctions[1].list && !sanctions[1].programs.filter(Boolean).length && !sanctions[1].remarks) {
                _sanctions = [sanctions[0]];
            }
        }

        api
            .updateVesselCompliance(vessel.imoNumber, complianceId, type, type === 'ofac' ? (_sanctions || sanctions) : (_detentions || detentions))
            .then((response) => {
                if (response.status && response.status !== 200) {
                    showErrorNotification(response.errors);
                } else {
                    showSuccessNotification(response.data.message);
                }
            });
    };

    const showSuccessNotification = (message) => {
        addNotification({
            title: 'Success',
            message,
            level: 'success',
            _id: new Date().getMilliseconds(),
            autoDismiss: 3,
        });
    };

    const showErrorNotification = (errors) => {
        addNotification({
            title: 'Error',
            message: Object.values(errors)[0].message,
            level: 'error',
            _id: new Date().getMilliseconds(),
            autoDismiss: 3,
        });
    };

    const clear = (type) => {
        const {
            detentions: defaultDetentions,
            sanctions: defaultSanctions,
        } = getDefaultDetentionsSanctions();

        if (type === 'ofac') {
            setSanctions(defaultSanctions);
        } else {
            setClearDetentions(true);
            setTimeout(() => {
                setDetentions(defaultDetentions);
                setTimeout(() => {
                    setClearDetentions(false);
                }, 0);
            }, 0);
        }
    };

    return (
        <div>
            <div className='table-header'>
                <div 
                    className='item'
                    style={{ display: 'flex' }}
                >   
                    <div 
                        style={{ width: '30%' }}
                    >
                        <VesselAutoComplete 
                            selectValue={selectVessel}
                        />
                    </div>
                    <div style={{ margin: 'auto 50px', fontSize: '14px' }}>
                        {
                            vessel && (
                                <span>{vessel.name} ({vessel.imoNumber})</span>
                            )
                        }
                    </div>
                </div>
            </div>
            <div className='table-body'>
                {
                    isLoading ?
                        <CircularProgress
                            className={!isLoading ? '' : 'hidden'}
                            style={styles.circularProgress}
                        />
                        :
                        vessel && 
                            <div>
                                <div className='item'>
                                    <span style={{ display: 'block', margin: '20px 0 0 0' }}>Sanctions</span>
                                    <Sanctions 
                                        changeFieldsMultiple={changeField}
                                        sanctions={sanctions}
                                    />
                                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <RaisedButton
                                            style={{ marginTop: '30px', marginRight: '30px' }}
                                            label='Clear'
                                            secondary
                                            onClick={() => clear('ofac')}
                                        />
                                        <RaisedButton
                                            style={{ marginTop: '30px', float: 'right' }}
                                            label='Save'
                                            primary
                                            onClick={() => updateCompliance('ofac')}
                                        />
                                    </div>
                                </div>
                                <div className='item'>
                                    <span style={{ display: 'block', margin: '20px 0 0 0' }}>Detentions</span>
                                    <Detentions 
                                        detentions={detentions}
                                        changeField={changeField}
                                        clearDetentions={clearDetentions}
                                    />
                                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <RaisedButton
                                            style={{ marginTop: '30px', marginRight: '30px' }}
                                            label='Clear'
                                            secondary
                                            onClick={() => clear('detentions')}
                                        />
                                        <RaisedButton
                                            style={{ marginTop: '30px', float: 'right' }}
                                            label='Save'
                                            primary
                                            onClick={() => updateCompliance('detentions')}
                                        />
                                    </div>
                                </div>
                            </div>
                }
            </div>
        </div>
    );
}

export default connect(
    null,
    dispatch => bindActionCreators(
        {
            addNotification,
        },
        dispatch,
    ),
)(DetentionsContent);

function getDefaultDetentionsSanctions() {
    return {
        sanctions: [
            {
                _id: '',
                list: '',
                programs: [],
                program: [],
                remarks: '',
            },
            {
                _id: '',
                list: '',
                programs: [],
                program: [],
                remarks: '',
            },
        ],  
        detentions: [{
            _id: '',
            detained: null,
            released: null,
            port: {
                _id: '',
                name: '',
                country: {
                    _id: '',
                    name: '',
                },    
            },
            deficienciesNumber: null,
            deficienciesNature: [],
        }],
    };
}



// WEBPACK FOOTER //
// ./app/components/Detentions/DetentionsContent.jsx